<template>
<div class="page container">
    <panel :extinfo="extinfo" ref="panel" :wapTitle="''" :appLink="'/2/8/0'" :spreadID="'0'" :showNav="false" @gotoApp="gotoApp" :isApp="false"></panel>
    <div class="folderInFo">
        <div class="folderName">{{dataList.shareInfo.title}}</div>
        <div class="userInfo">
            <div class="abWrap">
                <img :src="dataList.singleUserPic" alt="">
            </div>
            <span class="userName">{{ dataList.singleUserName }}</span>
        </div>
    </div>
    <div class="tags">
        <p>
            藏品列表（共<i>{{dataList.singleArtNums}}</i>件）
        </p>
    </div>
    <div class="lotList">
        <template v-for="(e,index) in dataList.auctions">
            <div class="listBox" :key="'listBox'+index">
                <dl class="fix" @click="gotoApp">
                    <dt>
                        <span class="imgWrap">
                            <img :src="e.coverPic" alt="">

                        </span>
                    </dt>
                    <dd>
                        <div class="lotName">
                            <span class="type grayBg">已结拍</span>
                            {{ e.show_title }}
                        </div>
                        <div class="orgInfo">
                            <template v-for="(item,itemIndex) in e.extraInfo">
                                  <div :key="'extra'+itemIndex">
                                <p class="PEle">
                                    <template v-if="item.type=='price'">
                                        <span class="icons transPrice"></span>
                                    <span class="price">{{item.nonMemberText}}</span>
                                    <em></em>
                                    </template>
                                    <template v-if="item.type=='text'">
                                        <span class="icons timeIcon"></span>
                                        {{item.text}}
                                    </template>
                                    <template  v-if="item.type=='company'">
                                        <span class="icons adressIcon"></span>
                                        {{item.text}}
                                    </template>
                                  
                                </p>
                            </div>

                            </template>
                        

                        </div>

                    </dd>
                </dl>

            </div>
            

        </template>
        <div class="noMore" >
                <span>我是有底线的</span>
        </div>
    </div>

    <DownLoadApp ref="downloadPop"></DownLoadApp>
</div>
</template>

<script>
import {
    dirsAuction
} from "@/api/auction";
import panel from "@/views/preview/component/panel";
import DownLoadApp from "@/components/common/downloadApp";

export default {
    data() {
        return {
            uid: '',
            headerImg: '',
            personName: '',
            extinfo: '',
            dataList: {
                singleUserName:'',
                singleArtNums:'',
                auctions:[],
                singleUserPic:'',
                shareInfo:{
                    title:''
                }
            },
            dirsData: {
                minId: 0,
                dirid: 0,
                type: 2,
                classCode: ''
            }
        };
    },
    watch: {},
    created() {
        if (this.$route.query.dirId) {

            this.dirsData.dirid = this.$route.query.dirId;
        }
        this.getdirsAuction();

    },
    mounted() {
        // this.uid = this.getCookie('_at_pt_0_') && this.getCookie('_at_pt_0_') > 0 ? this.formatZero(this.getCookie('_at_pt_0_')) : 0;
        // this.headerImg = this.getCookie('_at_pt_0_') && this.getCookie('_at_pt_0_') > 0 ? 'https://img12' + '.artimg.net/passport/avatar/' + this.uid.substring(0, 3) + '/' + this.uid.substring(3, 6) + '/' + this.uid.substring(6, 9) + '/150_150.png?t=' + new Date().getTime() : '';
        // this.personName = this.getCookie('_at_pt_1_') ? decodeURI(this.getCookie('_at_pt_1_')) : '';
        

    },
    methods: {
        getdirsAuction: function () {
            dirsAuction(this.dirsData).then((res) => {
                if (res.code == 0) {
                    this.dataList = res.data
                    document.title = this.dataList.shareInfo.title
                    this.extinfo=JSON.stringify({url: "myTuLu",param: this.$route.query.dirId+"@"+2+"@"+this.dataList.shareInfo.title})
                    console.log(res)
                }
            });
        },
        getCookie: function (name) {
            var arr;
            var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (document.cookie.match(reg)) {
                arr = document.cookie.match(reg);
                return arr[2];
            } else {
                return null;
            }
        },
        formatZero: function (num) {
            if (num.length < 9) {
                num = (Array(10 - num.length).join(0) + num);
                return num;
            } else {
                return num;
            }
        },
        gotoApp() {
            this.$refs.downloadPop.gotoAppDownload('/2/6', 0);
        },

    },
    components: {
        panel,
        DownLoadApp,

    },
};
</script>

<style lang="scss" scoped>
// 搜索头部和tab页面

.lotList {
    .listBox {
        background-color: #ffffff;
        padding: 0.5rem 0.75rem 0.75rem;
        margin-bottom: 1px;
        position: relative;

        .fix {

            dt {
                width: 3.75rem;
                height: 5rem;
                background-color: #e7e7e7;
                float: left;
                position: relative;

                .imgWrap {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-box-align: center;
                    -webkit-box-pack: center;
                    -webkit-box-orient: vertical;

                    img {
                        border: none;
                        vertical-align: middle;
                        max-width: 100%;
                        font-size: .3rem;
                    }
                }
            }
        }

        dd {
            margin-left: 3.75rem;
            padding-left: 0.5rem;

            .lotName {
                font-size: .7rem;
                line-height: 1rem;
                height: 2rem;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                color: #27282d;
                overflow: hidden;
                word-break: break-all;

                .grayBg {
                    background-color: #656565;
                }

                .type {
                    display: inline-block;
                    font-size: .5rem;
                    line-height: .7rem;
                    padding: 0 0.25rem;
                    margin-right: 0.25rem;
                    color: #ffffff;
                }
            }

            .orgInfo {
                font-size: .6rem;
                color: #969696;
                line-height: .9rem;
                margin-top: 0.3rem;

                .PEle {
                    display: inline-block;
                }

                .transPrice {
                    background-image: url("../../assets/img/icon_list_cheng_light@2x.png");
                }

                .timeIcon {
                    background-image: url("../../assets/img/icon_list_time_light@2x.png");
                }

                .adressIcon {
                    background-image: url("../../assets/img/icon_list_other_light@2x.png");
                }
               .price {
                    color: #e45558;
                    margin-right: 0.1rem;
                }

                em {
                    color: #e45558;
                    font-size: .35rem;
                }

                .icons {
                    display: inline-block;
                    width: 0.7rem;
                    height: 0.7rem;
                    vertical-align: middle;
                    background-position: center;
                    background-size: cover;
                    background-repeat: no-repeat;
                    margin-right: 0.25rem;
                    position: relative;
                    top: -0.08rem;
                }
            }
        }

        &::after {
            clear: both;
            content: "";
            display: table;
        }

        &::before {
            content: "";
            display: table;
        }
    }
}

.folderInFo {
    background: #ffffff;
    text-align: center;
    padding-top: 0.75rem;
    padding-bottom: 0.45rem;

    .folderName {
        font-size: .75rem;
        color: #27282d;
        margin-bottom: 0.45rem;
    }

    .userInfo {
        font-size: .6rem;
        color: #969696;
        line-height: .75rem;

        .abWrap {
            display: inline-block;
            width: 0.75rem;
            height: 0.75rem;
            border-radius: 50%;
            overflow: hidden;
            vertical-align: middle;
        }

        img {
            vertical-align: top;
            border: none;
            max-width: 100%;
            font-size: .3rem;
        }
    }
}

.tags {
    height: 1.75rem;
    background-color: #f2f2f2;
    padding: 0 0.75rem;

    p {
        font-size: .6rem;
        line-height: 1.75rem;
        color: #27282d;
    }

    i {
        font-style: normal;
    }
}
</style>
